import React from 'react';
export function BottomLinksSection() {
  return <div className="text-center pt-8 border-t border-gray-200" data-id="element-4118">
      <div className="flex flex-wrap justify-center items-center gap-4 text-lg font-bold" data-id="element-4119">
        <a href="59m7/agiecharmilles-edm.html" className="text-orange hover:underline" data-id="element-4120">
          AgieCharmilles EDM
        </a>
        <span className="text-gray-400" data-id="element-4121">|</span>
        <a href="59m7/agiecharmilles-edm/wire-edm.html" className="text-orange hover:underline" data-id="element-4122">
          Wire EDM
        </a>
        <span className="text-gray-400" data-id="element-4123">|</span>
        <a href="59m7/agiecharmilles-edm/sinker-edm.html" className="text-orange hover:underline" data-id="element-4124">
          Sinker EDM
        </a>
      </div>
    </div>;
}